import React, { useState, useEffect, useCallback } from 'react';
import API from '../api';

const sel = {
  padding: '7px 10px', border: '1px solid #d6d3d1', borderRadius: 6, fontSize: 13
};

const COLORI_AZIONE = {
  login:    { bg: '#EFF6FF', fg: '#1D4ED8' },
  crea:     { bg: '#F0FDF4', fg: '#166534' },
  modifica: { bg: '#FEFCE8', fg: '#854D0E' },
  elimina:  { bg: '#FEF2F2', fg: '#B91C1C' },
  rifiutato: { bg: '#FFF7ED', fg: '#C2410C' },
};

export default function AuditLog() {
  const [dati, setDati] = useState({ risultati: [], totale: 0, pagine_totali: 1 });
  const [utenti, setUtenti] = useState([]);
  const [filtri, setFiltri] = useState({ utente_id: '', azione: '', da: '', a: '' });
  const [pagina, setPagina] = useState(1);

  const carica = useCallback(() => {
    const params = { pagina, per_pagina: 50 };
    if (filtri.utente_id) params.utente_id = filtri.utente_id;
    if (filtri.azione) params.azione = filtri.azione;
    if (filtri.da) params.da = filtri.da;
    if (filtri.a) params.a = filtri.a;
    API.get('/audit', { params }).then(r => setDati(r.data)).catch(() => {});
  }, [filtri, pagina]);

  useEffect(() => { carica(); }, [carica]);
  useEffect(() => {
    API.get('/utenti').then(r => setUtenti(r.data)).catch(() => {});
  }, []);

  const setFiltro = (k, v) => { setFiltri({ ...filtri, [k]: v }); setPagina(1); };

  return (
    <div style={{ padding: 24, maxWidth: 1100 }}>
      <h2 style={{ marginTop: 0 }}>Audit log</h2>

      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        <select style={sel} value={filtri.utente_id} onChange={e => setFiltro('utente_id', e.target.value)}>
          <option value="">Tutti gli utenti</option>
          {utenti.map(u => <option key={u.id} value={u.id}>{u.nome} {u.cognome} (@{u.username})</option>)}
        </select>
        <select style={sel} value={filtri.azione} onChange={e => setFiltro('azione', e.target.value)}>
          <option value="">Tutte le azioni</option>
          <option value="login">Login</option>
          <option value="crea">Crea</option>
          <option value="modifica">Modifica</option>
          <option value="elimina">Elimina</option>
          <option value="rifiutato">Rifiutato</option>
        </select>
        <label style={{ fontSize: 13, color: '#57534e' }}>Dal</label>
        <input type="date" style={sel} value={filtri.da} onChange={e => setFiltro('da', e.target.value)} />
        <label style={{ fontSize: 13, color: '#57534e' }}>Al</label>
        <input type="date" style={sel} value={filtri.a} onChange={e => setFiltro('a', e.target.value)} />
        <span style={{ marginLeft: 'auto', fontSize: 13, color: '#78716c' }}>
          {dati.totale} eventi
        </span>
      </div>

      <div style={{ background: 'white', border: '1px solid #e7e5e4', borderRadius: 10, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ background: '#fafaf9', textAlign: 'left' }}>
              <th style={{ padding: '10px 14px' }}>Data e ora</th>
              <th style={{ padding: '10px 14px' }}>Utente</th>
              <th style={{ padding: '10px 14px' }}>Azione</th>
              <th style={{ padding: '10px 14px' }}>Dettaglio</th>
              <th style={{ padding: '10px 14px' }}>IP</th>
            </tr>
          </thead>
          <tbody>
            {dati.risultati.map(r => {
              const c = COLORI_AZIONE[r.azione] || { bg: '#F5F5F4', fg: '#44403C' };
              return (
                <tr key={r.id} style={{ borderTop: '1px solid #f5f5f4' }}>
                  <td style={{ padding: '9px 14px', whiteSpace: 'nowrap', color: '#57534e' }}>
                    {new Date(r.timestamp).toLocaleString('it-IT')}
                  </td>
                  <td style={{ padding: '9px 14px' }}>
                    {r.nome ? `${r.nome} ${r.cognome}` : `#${r.utente_id}`}
                  </td>
                  <td style={{ padding: '9px 14px' }}>
                    <span style={{ padding: '3px 10px', borderRadius: 20, fontSize: 12,
                                   fontWeight: 600, background: c.bg, color: c.fg }}>
                      {r.azione}
                    </span>
                  </td>
                  <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12, color: '#44403c' }}>
                    {r.entita || '—'}
                    {r.dettagli?.query ? `?${r.dettagli.query}` : ''}
                    {r.dettagli?.motivo && <div style={{ fontFamily: 'inherit', color: '#C2410C' }}>{r.dettagli.motivo}</div>}
                  </td>
                  <td style={{ padding: '9px 14px', color: '#78716c', fontSize: 12 }}>{r.ip_address}</td>
                </tr>
              );
            })}
            {dati.risultati.length === 0 && (
              <tr><td colSpan={5} style={{ padding: 20, textAlign: 'center', color: '#78716c' }}>
                Nessun evento trovato
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {dati.pagine_totali > 1 && (
        <div style={{ display: 'flex', gap: 10, marginTop: 14, alignItems: 'center', justifyContent: 'center' }}>
          <button disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}
            style={{ ...sel, cursor: pagina <= 1 ? 'default' : 'pointer', opacity: pagina <= 1 ? 0.5 : 1 }}>
            ← Precedente
          </button>
          <span style={{ fontSize: 13, color: '#57534e' }}>Pagina {pagina} di {dati.pagine_totali}</span>
          <button disabled={pagina >= dati.pagine_totali} onClick={() => setPagina(pagina + 1)}
            style={{ ...sel, cursor: pagina >= dati.pagine_totali ? 'default' : 'pointer',
                     opacity: pagina >= dati.pagine_totali ? 0.5 : 1 }}>
            Successiva →
          </button>
        </div>
      )}
    </div>
  );
}
